import React, { Component } from 'react';
import { connect } from 'react-redux';

class Home extends Component {
  componentDidMount() {
    if (this.props.auth.user.active === 0) {
      this.props.router.push('/confimation');
    } else {
      if (this.props.auth.user.type_id === 3) {
        this.props.router.push('/admin');
      }
    }
  }
  render() {
    return <div></div>;
  }
}
const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Home);
